import React, { useState } from 'react';

export default function DemoHeader({ demo }) {
    const [zoomed, setZoomed] = useState(false);

    return (
        <div className="demo-edit-header d-flex align-items-center pb-3 mb-4 border-bottom" data-testid="demo-edit-header">
            <div className="mr-3 flex-shrink-0">
                {demo.logo_url
                    ? <button
                        type="button"
                        className="btn p-0 border-0 bg-transparent demo-edit-header-logo-button"
                        aria-label={__('Enlarge logo')}
                        title={__('Enlarge logo')}
                        style={{ cursor: 'zoom-in' }}
                        onClick={() => setZoomed(true)}
                    >
                        <img
                            src={demo.logo_url}
                            alt={demo.name}
                            className="rounded img-fluid bg-white"
                            style={{ width: 96, height: 96, objectFit: 'contain' }}
                        />
                    </button>
                    : <div
                        className="rounded bg-light d-flex flex-column align-items-center justify-content-center text-center overflow-hidden font-weight-bold text-uppercase"
                        style={{ width: 96, height: 96, fontSize: 11, lineHeight: 1.1, padding: '0 10px' }}
                        role="img"
                        aria-label={__('Your company')}
                    >
                        {__('Your company')}
                    </div>
                }
            </div>
            <div>
                <h1 className="h3 mb-1 demo-island-text-wrap">{__('Demo account for :name', { ':name': demo.name })}</h1>
                {demo.address &&
                    <p className="mb-1 text-muted demo-island-text-wrap">
                        <i className="fas fa-map-marker-alt mr-1" aria-hidden="true" />
                        {demo.address}
                    </p>
                }
                <p className="mb-0 text-muted">{__('Use the links below to demonstrate our core features.')}</p>
            </div>

            {zoomed && demo.logo_url &&
                <div
                    className="demo-edit-header-logo-modal"
                    role="dialog"
                    aria-modal="true"
                    aria-label={__('Logo preview')}
                    onClick={() => setZoomed(false)}
                    style={{
                        position: 'fixed', inset: 0, zIndex: 1080, display: 'flex',
                        alignItems: 'center', justifyContent: 'center', padding: 24,
                        background: 'rgba(17, 24, 39, 0.6)', cursor: 'zoom-out',
                    }}
                >
                    <img
                        src={demo.logo_url}
                        alt={demo.name}
                        onClick={(event) => event.stopPropagation()}
                        style={{
                            maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain',
                            background: '#fff', borderRadius: 8, padding: 16,
                            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.35)', cursor: 'default',
                        }}
                    />
                    <button
                        type="button"
                        className="btn btn-light demo-edit-header-logo-close"
                        aria-label={__('Close')}
                        onClick={() => setZoomed(false)}
                        style={{ position: 'absolute', top: 16, right: 16 }}
                    >
                        <i className="fas fa-times" aria-hidden="true" />
                    </button>
                </div>
            }
        </div>
    );
}
